// extracted by mini-css-extract-plugin
module.exports = {"taskBoard":"Task_taskBoard__30f8Y","previewDropPosition":"Task_previewDropPosition__z7-Jl","projectTask":"Task_projectTask__3qAyE"};